import * as ActionTypes from './actionTypes';

export const getFinances = (payload) => ({
  type: ActionTypes.GET_FINANCES,
  payload,
});

export const getFinancesSuccess = (payload) => ({
  type: ActionTypes.GET_FINANCES_SUCCESS,
  payload,
});

export const getFinancesFailed = () => ({
  type: ActionTypes.GET_FINANCES_FAILED,
});

export const getFinanceOverview = (payload) => ({
  type: ActionTypes.GET_FINANCE_OVERVIEW,
  payload,
});

export const getFinanceOverviewSuccess = (payload) => ({
  type: ActionTypes.GET_FINANCE_OVERVIEW_SUCCESS,
  payload,
});

export const getFinanceOverviewFailed = () => ({
  type: ActionTypes.GET_FINANCE_OVERVIEW_FAILED,
});
